export default __webpack_public_path__ + "static/media/coldchain-edit-profile.dbd30e65.svg";